import React, { Component } from 'react';

// components
import Number from '../StepContent/Number';
import Inner from '../StepContent/Inner';
import {Field} from "redux-form";

const required = value => value ? undefined : 'Required';

class Step3 extends Component {

    // {/* use this "forEror" class for error message */}
    renderTextField({input, title, label, type, meta: {touched, error}}) {
        return <div className={`inputOuter ${touched && error ? 'forEror' : ''}`}>
            <span>{title}</span>
            <div className="inputWrap">
                <input {...input} className="form-control" placeholder={label} type={type}/>
            </div>
            <p className="text-danger">Enter a valid input</p>
        </div>;
    }

    render() {
        let classNames = (this.props.classDone) ? 'stepC ' : 'stepC disableAll';
        if (this.props.className) {
            classNames += ' stepSucc';
        }

        return (
            <div className={classNames}>
                <Number number='03' />
                <Inner>
                    <h3>Personal&nbsp;
                        <span>details </span></h3>
                    <div className="clearfix inputTwo">
                        <Field name="name"
                               label={''}
                               type="text"
                               title="Your name:"
                               component={this.renderTextField}
                               validate={[required]}
                        />
                        <Field name="email"
                               label={''}
                               type="email"
                               title="Your e-mail address:"
                               component={this.renderTextField}
                               validate={[required]}
                        />
                    </div>
                    <div className="clearfix inputTwo">
                        <Field name="phone"
                               label={''}
                               type="tel"
                               title="Your mobile number:"
                               component={this.renderTextField}
                               validate={[required]}
                        />
                        <Field name="referral_code"
                               label={''}
                               type="text"
                               title="Name of referrer (if applicable):"
                               component={this.renderTextField}
                        />
                    </div>
                    <div className="forNext">
                        <button type="button"
                                disabled={this.props.invalidSteps.indexOf("Step3") !== -1}
                                onClick={() => this.props.onClickNext()}
                                name="button" className="btn btn-danger text-uppercase">
                            next
                        </button>
                    </div>
                </Inner>
            </div>
        );
    }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/components/Membership/Step3/index.js